module.exports = __webpack_public_path__ + "static/img/p10-2.56da6cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mthfr/p10-2.png
// module id = N4ts
// module chunks = 0